export * from './erinnerung-gemerkt.interface';
